import { Component, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { DesignService, EcoService } from 'src/app/state';

@Component({
  selector: 'em-eco-table',
  templateUrl: './eco-table.component.html',
  standalone: false,
})
export class EcoTableComponent implements OnInit {
  public readonly trackByRef = trackByRef;
  public ecos$ = this.ecoService.ecos$;
  public ecosLoading$ = this.ecoService.loading$;
  public error$ = this.ecoService.error$;
  public designLoading$ = this.designService.loading$;

  public constructor(
    private readonly designService: DesignService,
    private readonly ecoService: EcoService
  ) {}

  public ngOnInit() {
    this.ecoService.loadByActiveEquipment().subscribe();
  }
}
